import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi";
import {
  getInitPopUp,
  getTablebySql,
  getInitPopUpData,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTabHeader from "@shared/components/SnTabHeader";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}
interface RowData {
  KeyField?: string;

  [key: string]: any;
}
const SN_PRD_WRK_REG_002_TEX_POP_004 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const [gridFocus, setGridFocus] = useState(false);
    const [popupParent, setPopupParent] = useState<any>(null);
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const searchRef = useRef<any>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
      },
      getSelectedRow: () => [
        gridRefs.current["grid1"].current.getChange() || [],
        gridRefs.current["grid2"].current.getChange() || [],
      ],
    }));
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useEffect(() => {
      const fetchform = async () => {
        try {
          //getinitformdata식으로 바껴야함
          const rtn: any = await getInitPopUpData(
            "SN_PRD_WRK_REG_002_TEX_POP_004",
            {}
          );
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormData(mergedData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          await onSearch();
        } catch (error: any) {}
      };
      fetchform();
    }, []);

    useEffect(() => {
      gridRefs.current["grid1"].current.selectAndFocusRow(0);
      setGridFocus(false);
    }, [gridFocus]);

    const onInsert = () => {
      try {
        const newRow = {};
        gridRefs.current["grid1"].current?.addRow(newRow);
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };
    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_prd_wrk_reg_004_tex_pop_01",
            params: {
              cd_firm: userInfo.cd_firm,
              no_po: selectedData.no_po,
              no_wo: selectedData.no_wo,
              cd_wh: selectedData.cd_wh,
              no_style: selectedData.no_style,
              qt_work: selectedData.qt_work,
              dt_io: selectedData.dt_io,
              cd_biz: selectedData.cd_biz,
              no_io: selectedData.no_io,
            },
          };

          const data: any = await fnGetDataSet(params);
          setDataSources({
            grid1: data[0],
            grid2: data[1] || [],
          });
          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            setGridFocus(true);
            gridRefs.current["grid1"].current.resetUpdate();
            gridRefs.current["grid2"].current.resetUpdate();
          } else {
            await onInsert();
          }
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      const qtio_tex = gridRefs.current["grid1"].current?.getChange();
      const qtio = gridRefs.current["grid2"].current?.getChange();
      if (
        qtio_tex.delete.modifiedRowcount < 1 ||
        qtio.delete.modifiedRowcount < 1
      ) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const grid1Count =
        gridRefs.current["grid1"].current.getDisplayedRowCount();
      const grid2Count =
        gridRefs.current["grid2"].current.getDisplayedRowCount();
      const mtlQtiohDeletes: any[] = [];
      if (grid1Count === 0 && grid2Count === 0) {
        mtlQtiohDeletes.push({
          cd_firm: userInfo.cd_firm,
          no_io: selectedData.no_io,
        });
      }
      const mtlQtiohChanges = {
        insert: [],
        update: [],
        delete: mtlQtiohDeletes,
        modifiedRowcount: mtlQtiohDeletes.length,
      };
      const SaveData = {
        mtl_qtioh: mtlQtiohChanges,
        mtl_qtio: qtio,
        mtl_qtio_tex: qtio_tex,
      };
      await fnSave("SN_PRD_WRK_REG_002_TEX_SAVE_04_POP", SaveData);
    };
    //#endregion

    const onCellValueChanged = async (event: CellValueChangedEvent) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;
      if (colId === "stock_qt") {
        rowNode.setDataValue(
          "use_qt",
          rowData.qt_w - rowData.stock_qt,
          "noEvent"
        );
      } else if (colId === "stock_qt_divide") {
        rowNode.setDataValue(
          "use_qt_divide",
          rowData.qt_divide_w - rowData.stock_qt_divide,
          "noEvent"
        );
      } else if (colId === "use_qt") {
        rowNode.setDataValue(
          "stock_qt",
          rowData.qt_w - rowData.use_qt,
          "noEvent"
        );
      } else if (colId === "use_qt_divide") {
        rowNode.setDataValue(
          "stock_qt_divide",
          rowData.qt_divide_w - rowData.use_qt_divide,
          "noEvent"
        );
      }
    };
    const onDeleteRow1 = () => {
      const gridApil = gridRefs.current["grid1"].current;
      const rowCount = gridApil.getDisplayedRowCount();
      if (rowCount === 0) {
        return;
      }

      const checkedRows = gridRefs.current["grid1"].current.getCheckedRows();

      const deleteIndexes: number[] = [];

      gridRefs.current["grid1"].current.forEachNode((node: any) => {
        if (!node.data) return;

        const isChecked = checkedRows.some((row: any) => row === node.data);

        if (isChecked) {
          deleteIndexes.push(node.rowIndex);
        }
      });

      // 🔥 index 밀림 방지 → 내림차순 정렬
      deleteIndexes
        .sort((a, b) => b - a)
        .forEach((index) => {
          gridRefs.current["grid1"].current.deleteRowByIndex(index);
        });
    };
    const onDeleteRow2 = () => {
      const gridApil = gridRefs.current["grid2"].current;
      const rowCount = gridApil.getDisplayedRowCount();
      if (rowCount === 0) {
        return;
      }
      const checkedRows = gridRefs.current["grid2"].current.getCheckedRows();

      const deleteIndexes: number[] = [];

      gridRefs.current["grid2"].current.forEachNode((node: any) => {
        if (!node.data) return;

        const isChecked = checkedRows.some((row: any) => row === node.data);

        if (isChecked) {
          deleteIndexes.push(node.rowIndex);
        }
      });

      // 🔥 index 밀림 방지 → 내림차순 정렬
      deleteIndexes
        .sort((a, b) => b - a)
        .forEach((index) => {
          gridRefs.current["grid2"].current.deleteRowByIndex(index);
        });
    };
    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
      gridRefs.current["grid2"].current.applyFilters({
        no_work: selectedRow.no_work,
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    };
    const onGridBtnsClick1 = async (id: string) => {
      //#region BtndeleteRow
      if (id === "deleteRow") {
        onDeleteRow1();
      }
    };
    const onGridBtnsClick2 = async (id: string) => {
      //#region BtndeleteRow
      if (id === "deleteRow") {
        onDeleteRow2();
      }
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged,
            onCellValueChanged: onCellValueChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCellValueChanged: onCellValueChanged,
          },
        },
      }),
      [columns, dataSources]
    );
    return (
      <div className="h-full flex flex-col">
        <div className="mb-1">
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
          />
        </div>
        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                title: "원단",
                rowSelection: "single",
                ischeckboxSelection: true,
              }}
              header={[<SnTabHeader onBtnDeleteClick={onGridBtnsClick1} />]}
              events={grids.grid1.events}
            />
          </div>
          <div style={{ height: "29vh", marginTop: "10px" }}>
            <div className="h-full">
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{
                  title: "기타",
                  rowSelection: "multiple",
                  ischeckboxSelection: true,
                }}
                header={[<SnTabHeader onBtnDeleteClick={onGridBtnsClick2} />]}
                events={grids.grid2.events}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default SN_PRD_WRK_REG_002_TEX_POP_004;
